import axios from 'axios';
import React, { useEffect, useState } from 'react';

const Logo = () => {
  const style = {
    width: '34%',
    marginLeft: '2%',
    height: '80%'
  };

  const [logo, setLogo] = useState('');
  const [loading, setLoading] = useState(true);

  const getLogo = (retries = 4, interval = 1000) => {
    setLoading(true);
    axios
      .get('api/logo/get')
      .then((response) => {
        setLogo(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        if (retries > 0) {
          setTimeout(() => getLogo(retries - 1, interval), interval);
        } else {
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    getLogo();
  }, []);

  if (loading) {
    return <div></div>;
  }

  const src = `data:image/jpg;base64, ${logo}`;

  return (
    <div className="headerLogo">
      <img style={style} src={src} alt="Logo" />
    </div>
  );
};

export default Logo;